"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CascaderMultiple = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var form_1 = require("../form");
var popover_1 = require("../popover");
var input_1 = require("../input");
var icon_1 = require("../icon");
var tag_1 = require("../tag");
var CascadeMenu_1 = require("./CascadeMenu");
var CascaderBox_1 = require("./CascaderBox");
var CascaderSearch_1 = require("./CascaderSearch");
var TagSelectInput_1 = require("../tagselect/TagSelectInput");
var use_default_1 = require("../_util/use-default");
var config_context_1 = require("../_util/config-context");
var i18n_1 = require("../i18n");
var noop_1 = require("../_util/noop");
var merge_event_props_1 = require("../_util/merge-event-props");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var util_1 = require("../util");
var CascaderMultiMenuLists_1 = require("./CascadeMenu/CascaderMultiMenuLists");
var CheckTree_1 = require("../checktree/CheckTree");
var defaultValueRender = function (options) {
    var leaf = options[options.length - 1];
    return (leaf === null || leaf === void 0 ? void 0 : leaf.label) || (leaf === null || leaf === void 0 ? void 0 : leaf.value) || "-";
};
function isEqual(a, b) {
    return a.length === b.length && a.every(function (str, i) { return str === b[i]; });
}
exports.CascaderMultiple = forward_ref_with_statics_1.forwardRefWithStatics(function CascaderMultiple(props, ref) {
    var t = i18n_1.useTranslation();
    var classPrefix = config_context_1.useConfig().classPrefix;
    var _a = form_1.useDefaultValue(props, []), data = _a.data, rawValue = _a.value, rawOnChange = _a.onChange, onLoad = _a.onLoad, disabled = _a.disabled, style = _a.style, className = _a.className, _b = _a.placeholder, placeholder = _b === void 0 ? t.pleaseSelect : _b, _c = _a.defaultOpen, defaultOpen = _c === void 0 ? false : _c, open = _a.open, _d = _a.onOpenChange, onOpenChange = _d === void 0 ? noop_1.noop : _d, _e = _a.placement, placement = _e === void 0 ? "bottom-start" : _e, _f = _a.placementOffset, placementOffset = _f === void 0 ? 5 : _f, _g = _a.closeOnScroll, closeOnScroll = _g === void 0 ? true : _g, escapeWithReference = _a.escapeWithReference, popupContainer = _a.popupContainer, overlayClassName = _a.overlayClassName, overlayStyle = _a.overlayStyle, clearable = _a.clearable, searchable = _a.searchable, filter = _a.filter, type = _a.type, expandTrigger = _a.expandTrigger, all = _a.all, _h = _a.valueRender, valueRender = _h === void 0 ? defaultValueRender : _h, _j = _a.valueMode, valueMode = _j === void 0 ? "onlyLeaf" : _j, _k = _a.showMode, showMode = _k === void 0 ? "onlyLeaf" : _k, tips = _a.tips, bottomTips = _a.bottomTips, _l = _a.onScrollBottom, onScrollBottom = _l === void 0 ? noop_1.noop : _l, _m = _a.onSearch, onSearch = _m === void 0 ? noop_1.noop : _m;
    var _o = tslib_1.__read(react_1.useState(false), 2), hover = _o[0], setHover = _o[1];
    var scheduleUpdateRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (scheduleUpdateRef.current) {
            scheduleUpdateRef.current();
        }
    }, [rawValue]);
    var _p = tslib_1.__read(use_default_1.useDefault(open, defaultOpen, onOpenChange), 2), isOpened = _p[0], setIsOpened = _p[1];
    var searchInputRef = react_1.useRef(null);
    var _q = tslib_1.__read(react_1.useState(""), 2), searchValue = _q[0], setSearchValue = _q[1];
    var _r = tslib_1.__read(react_1.useState(""), 2), fullSearchValue = _r[0], setFullSearchValue = _r[1];
    var _s = tslib_1.__read(react_1.useState(0), 2), wrapperWidth = _s[0], setWrapperWidth = _s[1];
    var Box = type === "menu" ? CascadeMenu_1.CascaderMenuBox : CascaderBox_1.CascaderBox;
    /**
     * -----------
     * 值类型转换
     * -----------
     */
    var _t = react_1.useMemo(function () {
        var relations = CascaderMultiMenuLists_1.getRelations(data, type === "menu" ? all : false).relations;
        return CheckTree_1.getRelationMap(relations);
    }, [all, data, type]), parentMap = _t.parentMap, childrenMap = _t.childrenMap;
    // 拼接多级值
    var _u = tslib_1.__read(react_1.useMemo(function () {
        var joinedValue = rawValue.map(function (list) { return list.join(CascaderMultiMenuLists_1.separator); });
        var joinedOnChange = function (value, context) {
            rawOnChange(value.map(function (i) { return i.split(CascaderMultiMenuLists_1.separator); }), {
                event: context === null || context === void 0 ? void 0 : context.event,
                options: value.map(function (i) { return CascaderBox_1.getOptions(data, i.split(CascaderMultiMenuLists_1.separator)); }),
            });
        };
        return [joinedValue, joinedOnChange];
    }, [data, rawOnChange, rawValue]), 2), joinedValue = _u[0], joinedOnChange = _u[1];
    // 只包含叶节点模式的拼接后的 value/onChange
    var _v = tslib_1.__read(CheckTree_1.useValueMode(joinedValue, joinedOnChange, parentMap, childrenMap, valueMode), 2), onlyLeafJoinedValue = _v[0], onlyLeafJoinedOnChange = _v[1];
    // 只包含叶节点模式的 value/onChange
    var _w = tslib_1.__read(react_1.useMemo(function () {
        var onlyLeafValue = onlyLeafJoinedValue.map(function (i) { return i.split(CascaderMultiMenuLists_1.separator); });
        var onlyLeafOnChange = function (value) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            onlyLeafJoinedOnChange.apply(void 0, tslib_1.__spread([value.map(function (i) { return i.join(CascaderMultiMenuLists_1.separator); })], args));
        };
        return [onlyLeafValue, onlyLeafOnChange];
    }, [onlyLeafJoinedOnChange, onlyLeafJoinedValue]), 2), onlyLeafValue = _w[0], onlyLeafOnChange = _w[1];
    var isSelected = react_1.useCallback(function (value) { return !!onlyLeafValue.find(function (v) { return isEqual(v, value); }); }, [onlyLeafValue]);
    var onSelect = function (value, context) {
        var next = tslib_1.__spread(onlyLeafValue, [value]);
        onlyLeafOnChange(next, tslib_1.__assign(tslib_1.__assign({}, context), { options: next.map(function (v) { return CascaderBox_1.getOptions(data, v); }) }));
    };
    var onDeselect = function (value, context) {
        var next = onlyLeafValue.filter(function (v) { return !isEqual(v, value); });
        onlyLeafOnChange(next, tslib_1.__assign(tslib_1.__assign({}, context), { options: next.map(function (v) { return CascaderBox_1.getOptions(data, v); }) }));
    };
    // showMode 转换渲染节点
    var tags = react_1.useMemo(function () {
        // 全选父节点 + 叶节点
        var allValue = CheckTree_1.getAllIds(onlyLeafJoinedValue, parentMap, childrenMap);
        if (showMode === "parentFirst") {
            var allSet_1 = new Set(allValue);
            var invalidSet_1 = new Set();
            allValue.forEach(function (id) {
                // 父节点此刻被选中则该节点无效
                if (parentMap.has(id) && allSet_1.has(parentMap.get(id))) {
                    invalidSet_1.add(id);
                }
            });
            // 转换后的 valueList
            var showValueList_1 = allValue
                .filter(function (id) { return !invalidSet_1.has(id); })
                .map(function (i) { return i.split(CascaderMultiMenuLists_1.separator); });
            var optionsList_1 = showValueList_1
                .map(function (v) { return CascaderBox_1.getOptions(data, v); })
                .filter(Boolean);
            return optionsList_1.map(function (options) {
                var _a, _b;
                var key = options.map(function (i) { return i.value; }).join(CascaderMultiMenuLists_1.separator);
                // all 配置比较特殊，无法在 getOptions 中找到
                if (key === (((_a = all) === null || _a === void 0 ? void 0 : _a.value) || CascaderMultiMenuLists_1.defaultAllValue)) {
                    options[0].label = ((_b = all) === null || _b === void 0 ? void 0 : _b.label) || t.selectAllText;
                }
                return (react_1.default.createElement(tag_1.Tag, { key: key, onClose: function (event) {
                        event.stopPropagation();
                        if (disabled) {
                            return;
                        }
                        var next = onlyLeafValue.filter(function (value) {
                            var curKey = value.join(CascaderMultiMenuLists_1.separator);
                            var result = true;
                            while (curKey) {
                                if (curKey === key) {
                                    result = false;
                                    break;
                                }
                                curKey = parentMap.get(curKey);
                            }
                            return result;
                        });
                        onlyLeafOnChange(next, {
                            event: event,
                            options: next.map(function (v) { return CascaderBox_1.getOptions(data, v); }),
                        });
                    } }, valueRender(options)));
            });
        }
        // if (showMode === "onlyLeaf")
        // 转换后的 valueList
        var showValueList = allValue
            .filter(function (i) { return !childrenMap.has(i); })
            .map(function (i) { return i.split(CascaderMultiMenuLists_1.separator); });
        var optionsList = showValueList
            .map(function (v) { return CascaderBox_1.getOptions(data, v); })
            .filter(Boolean);
        return optionsList.map(function (options) {
            var key = options.map(function (i) { return i.value; }).join(CascaderMultiMenuLists_1.separator);
            return (react_1.default.createElement(tag_1.Tag, { key: key, onClose: function (event) {
                    event.stopPropagation();
                    if (disabled) {
                        return;
                    }
                    var next = onlyLeafValue.filter(function (value) { return value.join(CascaderMultiMenuLists_1.separator) !== key; });
                    onlyLeafOnChange(next, {
                        event: event,
                        options: next.map(function (v) { return CascaderBox_1.getOptions(data, v); }),
                    });
                } }, valueRender(options)));
        });
    }, [
        onlyLeafJoinedValue,
        parentMap,
        childrenMap,
        showMode,
        data,
        all,
        valueRender,
        t.selectAllText,
        disabled,
        onlyLeafValue,
        onlyLeafOnChange,
    ]);
    return (react_1.default.createElement(popover_1.Popover, { trigger: disabled ? "empty" : "click", visible: isOpened, onVisibleChange: setIsOpened, onExited: function () {
            setSearchValue("");
            setFullSearchValue("");
        }, placement: placement || "bottom-start", placementOffset: placementOffset, closeOnScroll: closeOnScroll, escapeWithReference: escapeWithReference, popupContainer: popupContainer, overlayClassName: overlayClassName, overlayStyle: overlayStyle, overlay: function (_a) {
            var scheduleUpdate = _a.scheduleUpdate;
            scheduleUpdateRef.current = scheduleUpdate;
            if (searchValue) {
                return (react_1.default.createElement(CascaderSearch_1.CascaderSearch, { multiple: true, data: data, searchValue: searchValue, filter: filter, changeOnSelect: false, isSelected: isSelected, onChange: function (value, _a) {
                        var selected = _a.selected, context = tslib_1.__rest(_a, ["selected"]);
                        if (selected) {
                            onSelect(value, context);
                        }
                        else {
                            onDeselect(value, context);
                        }
                    }, tips: tips, bottomTips: bottomTips, onScrollBottom: onScrollBottom, onSearch: onSearch }));
            }
            return (react_1.default.createElement(Box, { multiple: true, all: all, curValueList: onlyLeafValue, data: data, onChange: onlyLeafOnChange, onSelect: onSelect, onLoad: onLoad, onClose: function () { return setIsOpened(false); }, changeOnSelect: false, scheduleUpdate: scheduleUpdate, isSelected: isSelected, onDeselect: onDeselect, expandTrigger: expandTrigger, tips: tips, bottomTips: bottomTips, onScrollBottom: onScrollBottom }));
        } },
        react_1.default.createElement("div", tslib_1.__assign({ className: classnames_1.default(classPrefix + "-cascader", className, {
                "is-disabled": disabled,
            }), style: style, ref: util_1.mergeRefs(ref, function (ref) { return ref && setWrapperWidth(ref.clientWidth); }) }, merge_event_props_1.mergeEventProps(props, {
            onMouseEnter: function () { return setHover(true); },
            onMouseLeave: function () { return setHover(false); },
        })),
            react_1.default.createElement("div", { className: classPrefix + "-cascader__input", onClick: function (event) {
                    if (disabled) {
                        return;
                    }
                    if (searchable && searchInputRef.current) {
                        event.stopPropagation();
                        searchInputRef.current.focus();
                        setIsOpened(true);
                    }
                } },
                react_1.default.createElement("div", { className: classPrefix + "-cascader__value" },
                    react_1.default.createElement(tag_1.Tag.Group, null,
                        tags,
                        searchable && (react_1.default.createElement(TagSelectInput_1.TagSelectInput, { disabled: disabled, className: classPrefix + "-input--editor", ref: searchInputRef, maxWidth: wrapperWidth, reservedWidth: 2, value: searchValue, onChange: function (value) {
                                setSearchValue(value);
                            }, onInput: function (event) {
                                setFullSearchValue(event.currentTarget.value);
                            } })))),
                !fullSearchValue && (react_1.default.createElement(input_1.Input, { readonly: true, autoComplete: "off", placeholder: onlyLeafValue.length ? "" : placeholder }))),
            clearable && !disabled && hover && onlyLeafValue.length ? (react_1.default.createElement(icon_1.Icon, { type: "dismiss", onClick: function (event) {
                    event.stopPropagation();
                    onlyLeafOnChange([], { event: event, options: [] });
                } })) : (react_1.default.createElement(icon_1.Icon, { type: "arrowdown" })))));
}, {
    defaultLabelAlign: "middle",
});
exports.CascaderMultiple.displayName = "CascaderMultiple";
//# sourceMappingURL=CascaderMultiple.js.map